import React from "react";

export function SectionLabel({ code, children, className = "" }) {
  return (
    <div
      className={`flex items-center gap-3 font-mono text-[10px] tracking-[0.3em] uppercase text-[#F39C12] ${className}`}
    >
      {code && <span className="opacity-70">{code}</span>}
      <span className="h-px w-8 bg-[#F39C12]" />
      <span>{children}</span>
    </div>
  );
}

export function SectionHeading({ overline, code, title, subtitle, light = false }) {
  return (
    <div className="max-w-3xl">
      {overline && <SectionLabel code={code}>{overline}</SectionLabel>}
      <h2 className={`mt-4 font-heading font-black text-3xl md:text-4xl lg:text-5xl tracking-tight uppercase ${light ? "text-[#050A0F]" : "text-[#F8FAFC]"}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 text-base md:text-lg leading-relaxed ${light ? "text-[#1F3550]" : "text-[#94A3B8]"}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
